import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";


import seoConfig from "@/data/seo.config";
import SeoHelmet from "@/components/SeoHelmet";

import { fetchHomePageData } from "@/store/modern/slices/promotionMediaSlice";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import FindPartner from "@/modules/frontend/components/Home/FindPartner";
import Statistics from "@/modules/frontend/components/Home/Statistics";
import OurBenefits from "@/modules/frontend/components/Home/OurBenefits";

import HeroBanner from "@/modules/frontend/components/Home/HeroBanner";
import Testimonials from "@/modules/frontend/components/Home/Testimonials";
import PartnerLogos from "@/modules/frontend/components/Home/PartnerLogos";
import InquiryList from "@/modules/frontend/components/Inquiry/InquiryList";
import PartnerBanners from "@/modules/frontend/components/Home/PartnerBanners";
import GlobalTrade from "@/modules/frontend/components/Home/GlobalTrade";
import Industries from "@/modules/frontend/components/Home/Industries";


const Index = () => {

  const [scrolled, setScrolled] = useState(false);
  const dispatch = useDispatch();
  const heroBanners = useSelector(state => state.promotion_media.hero_banner, shallowEqual);
  const ourPartner = useSelector(state => state.promotion_media.partner_logos, shallowEqual);
  const promotionPartner = useSelector(state => state.promotion_media.promotion_partner, shallowEqual);
  const mockInquiry = useSelector(state => state.promotion_media.mock_inquiry, shallowEqual);
  const testimonials = useSelector(state => state.promotion_media.testimonials, shallowEqual);
  const ipAndCountry = useSelector((state) => state.countries?.ipAndCountry || null, shallowEqual);

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY >= 400);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // await dispatch(getIPWithLocation());
      // await dispatch(fetchHeroBanners());
      // await dispatch(fetchOurPartners());
      // await dispatch(fetchPromotionPartners());
      // await dispatch(fetchMockInquiry());
      // await dispatch(fetchTestimonials());

      await dispatch(fetchHomePageData());
    };

    fetchData();
  }, []);


  return (<><section id="v3" >
    <SeoHelmet
      title={seoConfig.home.title}
      description={seoConfig.home.description}
      keywords={seoConfig.home.keywords}
      author={seoConfig.home.author}
    />
    <button
      className="btn outline small sticky-btn"
      onClick={handleQuoteClick}
      type="button"
    >
      Book A Demo
    </button>

    <HeroBanner heroBanners={heroBanners} />

    <section className="find-partner-stats-wrape">
      <FindPartner />
      <Statistics />
    </section>

    <section className="pramotional-benefits-wrape">
      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
            <PartnerBanners promotionPartner={promotionPartner} />
          </div>
          <OurBenefits />
        </div>
      </div>
    </section>

    <section className="inquiry-wrape">
      <InquiryList mockInquiry={mockInquiry} />
    </section>
    <Industries />


    <PartnerLogos ourPartner={ourPartner} />


    <section className="book-demo-testimonial-wrape">
      <div className="inner-pad-bg">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12">
              <Testimonials testimonialData={testimonials} />
            </div>
          </div>
        </div>
      </div>
    </section>

    <GlobalTrade />

  </section>

    <ConsentManager data={ipAndCountry} />

    {smallmodalShow && (
      <PopUp
        title="Book A Demo"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        className="book-demo"
      >
        <BookADemo
          setSmallModalShow={setSmallModalShow} />
      </PopUp>
    )}
    <ToastContainer />
    
  </>
  )
}



export default Index;
